import {
  boldFont,
  getRelativeFontSize,
  mediumFont,
  regularFont,
} from "../../../utils/styles";

const CustomPageHeaderStyles = {
  headingSection: {
   
  },
  heading: {
    ...boldFont,
    fontSize: "18px",
    textTransform:"capitalize",
  },
  subText: {
    color: "#718096",
    ...regularFont,
    fontSize: "12px",
  },
};

export default CustomPageHeaderStyles;
